module.exports = __webpack_public_path__ + "img/ic_food_japan.49bfdbc8.png";